/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import { motion } from "framer-motion";
// @mui material components
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";
import MDButton from "../../../../components/MDButton";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import constants from "../../../../common/constants";

function IdLinkCell({ id, checked, object }) {
  var path = "amm/app/dashboard/view-estate-ticket";

  switch (object.Object_Type) {
    case "Estate":
      path = toLinkPath("amm/app/dashboard/view-estate-ticket");
      break;
    case "Property_Group":
      path = toLinkPath("amm/app/dashboard/view-property-group-ticket");
      break;
    case "Building":
      path = toLinkPath("amm/app/dashboard/view-building-ticket");
      break;
    case "Space":
      path = toLinkPath("amm/app/dashboard/view-space-ticket");
      break;
    case "Asset":
      path = toLinkPath("amm/app/dashboard/view-asset-ticket");
      break;
  }

  const handleSubmit = () => {
    // navigate(path + "?id=" + object.id, { state: object });
    window.location.href = `./${path}?id=${object.id}`;
  };

  function toLinkPath(myPath) {
    if (
      object.Ticket_Action_Type === "BatchCreate" ||
      object.Ticket_Action_Type === "BatchUpdate"
    ) {
      myPath += "-batch";
    }
    return myPath;
  }

  return (
    <MDBox display="flex" alignItems="center">
      <motion.div
        whileHover={{
          scale: 1.03,
          transition: { duration: 0 },
        }}
        onClick={handleSubmit}
      >
        <MDBox ml={1}>
          <MDTypography variant="caption" fontWeight="bold" color="primary">
            {`${id}`}
          </MDTypography>
        </MDBox>
      </motion.div>
    </MDBox>
  );
}

// Setting default value for the props of IdCell
IdLinkCell.defaultProps = {
  checked: false,
};

// Typechecking props for the IdCell
IdLinkCell.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
};

export default IdLinkCell;
